import { render, staticRenderFns } from "./GenreCategorySettingDialog.vue?vue&type=template&id=7de67125&scoped=true"
import script from "./GenreCategorySettingDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenreCategorySettingDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GenreCategorySettingDialog.vue?vue&type=style&index=0&id=7de67125&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de67125",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de67125')) {
      api.createRecord('7de67125', component.options)
    } else {
      api.reload('7de67125', component.options)
    }
    module.hot.accept("./GenreCategorySettingDialog.vue?vue&type=template&id=7de67125&scoped=true", function () {
      api.rerender('7de67125', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/novel/GenreCategorySettingDialog.vue"
export default component.exports